export default "__VITE_ASSET__BQ86G22g__"